module.exports = __webpack_public_path__ + "images/imagebetter3.6cfef433.png";